import React from 'react';

import { PAYMENT_SECTION_ID } from '@/constants';
import { useStripeV2Payment } from '@/hooks/useStripeV2Payment';
import { useStripeV2Plans } from '@/hooks/useStripeV2Plans';
import { PaymentOnPageDescription } from '@/pages/Paywall/sections/PaymentOnPage/components/Description';
import { PaymentOnPageSubscriptions } from '@/pages/Paywall/sections/PaymentOnPage/components/Subscriptions';
import { scrollToById } from '@/utils/scrollToById';

import { SelectPlanButtonStyles, SelectPlanStyles } from './SelectPlan.styles';

export const SectionSelectPlan: React.FC = () => {
  const { isLoadingPlans, isSuccess, stripePlans, selectedPlan, monthlyPlan } =
    useStripeV2Plans();

  const { isLoading: isCreatingStripeSubscription } = useStripeV2Payment();

  return (
    <SelectPlanStyles>
      <PaymentOnPageSubscriptions
        isLoadingConfig={isLoadingPlans}
        isCreatingSubscription={isCreatingStripeSubscription}
        isSuccess={isSuccess}
        stripePlans={stripePlans}
        theme={'dark-forest'}
      />
      <SelectPlanButtonStyles
        type="button"
        disabled={isLoadingPlans}
        onClick={() => {
          scrollToById(PAYMENT_SECTION_ID);
        }}
      >
        UNLOCK THE ENDING
      </SelectPlanButtonStyles>

      <PaymentOnPageDescription plan={selectedPlan} monthlyPlan={monthlyPlan} />
    </SelectPlanStyles>
  );
};
